/**
 * Script para diagnosticar productos duplicados
 */

export const diagnoseProductDuplicates = async () => {
  try {
    console.log('🔍 === DIAGNÓSTICO DE PRODUCTOS DUPLICADOS ===');
    
    // 1. Verificar usuario
    const auth = window.auth.auth;
    const user = auth.currentUser;

    if (!user) {
      console.error('❌ Usuario no autenticado');
      return;
    }
    console.log('✅ Usuario autenticado:', user.uid);

    // 2. Cargar productos desde el servicio
    console.log('\n📦 Cargando productos desde inventoryService...');
    const inventoryService = (await import('../services/inventoryService')).default;
    const products = await inventoryService.getProductsFromDocumentedStructure();
    
    console.log(`📊 Total productos cargados: ${products.length}`);
    
    // 3. Verificar duplicados por SKU
    console.log('\n🔍 Verificando duplicados por SKU...');
    const skuCounts: Record<string, number> = {};
    const duplicateSkus: string[] = [];
    
    products.forEach(product => {
      const sku = product.sku || product.id;
      skuCounts[sku] = (skuCounts[sku] || 0) + 1;
      if (skuCounts[sku] > 1) {
        duplicateSkus.push(sku);
      }
    });
    
    console.log(`📊 SKUs únicos: ${Object.keys(skuCounts).length}`);
    console.log(`⚠️ SKUs duplicados: ${duplicateSkus.length}`);
    
    if (duplicateSkus.length > 0) {
      console.log('🔍 SKUs duplicados:', duplicateSkus);
      duplicateSkus.forEach(sku => {
        const duplicates = products.filter(p => (p.sku || p.id) === sku);
        console.log(`  - ${sku}: ${duplicates.length} veces`);
        duplicates.forEach((dup, index) => {
          console.log(`    ${index + 1}. ${dup.name} (${dup.category})`);
        });
      });
    }
    
    // 4. Verificar duplicados por ID
    console.log('\n🔍 Verificando duplicados por ID...');
    const idCounts: Record<string, number> = {};
    const duplicateIds: string[] = [];
    
    products.forEach(product => {
      idCounts[product.id] = (idCounts[product.id] || 0) + 1;
      if (idCounts[product.id] > 1) {
        duplicateIds.push(product.id);
      }
    });
    
    console.log(`📊 IDs únicos: ${Object.keys(idCounts).length}`);
    console.log(`⚠️ IDs duplicados: ${duplicateIds.length}`);
    
    if (duplicateIds.length > 0) {
      console.log('🔍 IDs duplicados:', duplicateIds);
    }
    
    // 5. Agrupar por categoría
    console.log('\n📂 Productos por categoría:');
    const productsByCategory: Record<string, any[]> = {};
    products.forEach(product => {
      const category = product.category || 'Sin categoría';
      if (!productsByCategory[category]) {
        productsByCategory[category] = [];
      }
      productsByCategory[category].push(product);
    });
    
    Object.entries(productsByCategory).forEach(([category, categoryProducts]) => {
      console.log(`  ${category}: ${categoryProducts.length} productos`);
      const categorySkus = categoryProducts.map(p => p.sku || p.id);
      const uniqueSkus = Array.from(new Set(categorySkus));
      if (categorySkus.length !== uniqueSkus.length) {
        console.log(`    ⚠️ Duplicados en ${category}: ${categorySkus.length - uniqueSkus.length}`);
      }
    });
    
    // 6. Verificar productos con datos faltantes
    console.log('\n🔍 Verificando productos con datos faltantes:');
    const productsWithMissingData = products.filter(p => 
      !p.name || !p.category || !p.sku
    );
    
    console.log(`⚠️ Productos con datos faltantes: ${productsWithMissingData.length}`);
    if (productsWithMissingData.length > 0) {
      productsWithMissingData.forEach((product, index) => {
        console.log(`  ${index + 1}. ID: ${product.id}`);
        console.log(`     - Nombre: ${product.name || 'FALTANTE'}`);
        console.log(`     - Categoría: ${product.category || 'FALTANTE'}`);
        console.log(`     - SKU: ${product.sku || 'FALTANTE'}`);
      });
    }
    
    console.log('\n✅ === DIAGNÓSTICO COMPLETADO ===');
    
    return {
      success: true,
      totalProducts: products.length,
      uniqueSkus: Object.keys(skuCounts).length,
      duplicateSkus: duplicateSkus.length,
      uniqueIds: Object.keys(idCounts).length,
      duplicateIds: duplicateIds.length,
      productsWithMissingData: productsWithMissingData.length,
      productsByCategory: Object.keys(productsByCategory).length
    };

  } catch (error) {
    console.error('❌ Error en diagnóstico:', error);
    return {
      success: false,
      error: error
    };
  }
};

// Hacer disponible en consola
if (typeof window !== 'undefined') {
  (window as any).diagnoseProductDuplicates = diagnoseProductDuplicates;
}